import React from 'react';
 

const Dashboard = React.lazy(() => import('./views/pages/dashboard/Dashboard'));
const DashboardWebNgc = React.lazy(() => import('./views/pages/dashboard/DashboardWebNgc'));

const Ngc_s = React.lazy(() => import('./views/pages/NgcWeb/Ngc_S'));
const Ngc_d = React.lazy(() => import('./views/pages/NgcWeb/Ngc_D'));
const Ngc_p = React.lazy(() => import('./views/pages/NgcWeb/Ngc_P'));
const Ngc_Article = React.lazy(() => import('./views/pages/NgcWeb/Ngc_Article'));
const Ngc_About = React.lazy(() => import('./views/pages/NgcWeb/Ngc_About'));
 
const Ngc_Article_Detail = React.lazy(() => import('./views/pages/NgcWeb/Ngc_Article_Detail'));


const Login = React.lazy(() => import('./views/pages/login/Login'));

const DashboardAcard = React.lazy(() => import('./views/pages/dashboard/DashboardAcard'));


const DashboardAccounting = React.lazy(() => import('./views/pages/dashboard/DashboardAccounting'));
const DashboardReservate = React.lazy(() => import('./views/pages/dashboard/DashboardReservate'));
const DashboardSaleInfo = React.lazy(() => import('./views/pages/dashboard/DashboardSaleInfo'));
const DashboardPerson = React.lazy(() => import('./views/pages/dashboard/DashboardPerson'));
const DashboardPayment_Check = React.lazy(() => import('./views/pages/dashboard/DashboardPayment_Check'));
const DashboardMessage = React.lazy(() => import('./views/pages/dashboard/DashboardMessage'));
const DashboardFileImage = React.lazy(() => import('./views/pages/dashboard/DashboardFileImage'));
const DashboardSummary = React.lazy(() => import('./views/pages/dashboard/DashobardSummary'));
const DashboardFileKeep = React.lazy(() => import('./views/pages/dashboard/DashboardFileKeep'));

const DashboardStock = React.lazy(() => import('./views/pages/dashboard/DashboardStock'));
const Dashboard_Activity = React.lazy(() => import('./views/pages/dashboard/Dashboard_Activity'));

const Acard = React.lazy(() => import('./views/pages/Sales/Acard'));
const Acard_List = React.lazy(() => import('./views/pages/Sales/Acard_List'));
const Acard_Info = React.lazy(() => import('./views/pages/Sales/Acard_Info'));
const AcardInputDetail = React.lazy(() => import('./views/pages/Acard/AcardInputDetail'));
const Acard_InputInfo = React.lazy(() => import('./views/pages/Acard/Acard_InputInfo'));
const Acard_InputAddress = React.lazy(() => import('./views/pages/Acard/Acard_InputAddress'));
const Acard_InputModel = React.lazy(() => import('./views/pages/Acard/Acard_InputModelcar'));
const Acard_Campaign = React.lazy(() => import('./views/pages/Acard/Acard_InputCampaign'));
const Acard_InputContact = React.lazy(() => import('./views/pages/Acard/Acard_InputContact'));
const Acard_NewContact = React.lazy(() => import('./views/pages/Acard/Acard_NewContact'));
const Acard_InputPayment = React.lazy(() => import('./views/pages/Acard/Acard_InputPayment'));
const Acard_InputPartsetitems = React.lazy(() => import('./views/pages/Acard/Acard_InputPartsetitems'));
const Acard_InputFee = React.lazy(() => import('./views/pages/Acard/Acard_InputFee'));
const Acard_ScoreCard = React.lazy(() => import('./views/pages/Acard/Acard_ScoreCard'));
const Acard_FormScoreCard = React.lazy(() => import('./views/pages/Acard/Acard_FormScoreCard'));
const Acard_Payment = React.lazy(() => import('./views/pages/Acard/Acard_Payment'));
const Acard_Payment_Slip = React.lazy(() => import('./views/pages/Acard/Acard_Payment_slip'));
const Acard_Reservate = React.lazy(() => import('./views/pages/Acard/Acard_Reservate'));
const Acard_Reservate_Info = React.lazy(() => import('./views/pages/Acard/Acard_Reservate_info'));

const Acard_Form_Reservate_New = React.lazy(() => import('./views/pages/Acard/Acard_Form_Reservate_new'));
const Acard_Form_OCPB_Memo2 = React.lazy(() => import('./views/pages/Acard/Acard_Form_OCPB_Memo2'));
const Acard_Form_OCPB_Memo1 = React.lazy(() => import('./views/pages/Acard/Acard_Form_OCPB_Memo1'));
const Acard_Form_OCPB = React.lazy(() => import('./views/pages/Acard/Acard_Form_OCPB'));
const Acard_OCPB = React.lazy(() => import('./views/pages/Acard/Acard_OCPB'));
const Acard_Quatation_list = React.lazy(() => import('./views/pages/Acard/Acard_Quatation_list'));
const Acard_FormQuatation = React.lazy(() => import('./views/pages/Acard/Acard_FormQuatation'));
const Acard_Quatation = React.lazy(() => import('./views/pages/Acard/Acard_Quatation'));
const Acard_FormQuatation_approve = React.lazy(() => import('./views/pages/Acard/Acard_FormQuatation_approve'));
const Acard_FormQR_approve = React.lazy(() => import('./views/pages/Acard/Acard_FormQR_approve'));
const Acard_FormQR_sale = React.lazy(() => import('./views/pages/Acard/Acard_FormQR_sale'));
const Acard_Approve_list = React.lazy(() => import('./views/pages/Acard/Acard_Approve_list'));
const Acard_Transfer_Reservate = React.lazy(() => import('./views/pages/Acard/Acard_TransferReservate'));
const Acard_InputInviteAddress = React.lazy(() => import('./views/pages/Acard/Acard_InputInviteAddress'));

const Acard_Approve_Cancel_Bk = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Cancel_Bk'));
const Acard_Approve_Tbr_Fc = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Tbr_Fc'));
const Acard_Approve_Booking_Vip = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Booking_Vip'));
const Acard_Approve_Invite = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Invite'));
const Acard_Approve_Acc_BKCancel = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Acc_BKCancel'));
const Acard_Approve_Acc_Invite = React.lazy(() => import('./views/pages/Acard/Acard_Approve_Acc_Invite'));
const Acard_Approve_OCPB = React.lazy(() => import('./views/pages/Acard/Acard_Approve_OCPB'));
const Acard_Form_QM1 = React.lazy(() => import('./views/pages/Acard/Acard_Form_QM1'));
const Acard_Form_QM1_View = React.lazy(() => import('./views/pages/Acard/Acard_Form_QM1_View'));

const Acard_Approve_QM1 = React.lazy(() => import('./views/pages/Acard/Acard_Approve_QM1'));

const Acard_Receiptcar_list = React.lazy(() => import('./views/pages/Acard/Acard_Receiptcar_list'));
const Acard_Receiptcar = React.lazy(() => import('./views/pages/Acard/Acard_Receiptcar'));
const Acard_FormReceiptcar = React.lazy(() => import('./views/pages/Acard/Acard_FormReceiptcar'));

const Acard_Cancel_Advancepay = React.lazy(() => import('./views/pages/Acard/Acard_Cancel_Advancepay'));
const Acard_FK_Invite = React.lazy(() => import('./views/pages/Acard/Acard_FK_Invite'));

const Filekeep = React.lazy(() => import('./views/pages/Filekeep/Filekeep'));
const Filekeep2 = React.lazy(() => import('./views/pages/Filekeep/Filekeep2'));
const FileTypelist = React.lazy(() => import('./views/pages/Filekeep/FileTypelist'));
const Filelist = React.lazy(() => import('./views/pages/Filekeep/FileList'));
const AcardFilelist = React.lazy(() => import('./views/pages/Filekeep/AcardFileList'));




const Job_Modelspec = React.lazy(() => import('./views/pages/Sales/Job_InputModelSpec'));
const Job_Modelname = React.lazy(() => import('./views/pages/Sales/Job_InputModelname'));
const Job_InputSelect = React.lazy(() => import('./views/pages/Sales/Job_InputSelect'));
const Job_InputTarget = React.lazy(() => import('./views/pages/Sales/Job_InputTarget'));

const DB_Exportexcelteam = React.lazy(() => import('./views/pages/Sales/DB_ExportExcel_Team'));
const DB_JobFormPDF = React.lazy(() => import('./views/pages/Sales/DB_JobFormPDF'));

const Users = React.lazy(() => import('./views/pages/Users/UserList'));
const User = React.lazy(() => import('./views/pages/Users/User'));
const NewUser = React.lazy(() => import('./views/pages/Users/NewUser'));
const UserAuthorize = React.lazy(() => import('./views/pages/Users/UserAuthorize'));

const MenuItem = React.lazy(() => import('./views/pages/Users/MenuItem'));
const MenuItems = React.lazy(() => import('./views/pages/Users/MenuItems'));

const OTP_List = React.lazy(() => import('./views/pages/Otp/Otp_List'));



// ========================== DB ============================= 

const DB_PDFsummaryBySales = React.lazy(() => import('./views/pages/Sales/DB_PDFsummaryBySales'));
const DB_PDFsummaryBySales_detail = React.lazy(() => import('./views/pages/Sales/DB_PDFsummaryBySales_detail'));

const DB_Summary_by_job = React.lazy(() => import('./views/pages/Sales/DB_Summary_by_Job'));
const DB_Summary_by_sales = React.lazy(() => import('./views/pages/Sales/DB_Summary_by_sales'));
const DB_JobList = React.lazy(() => import('./views/pages/Sales/DB_JobList'));
const DB_Acard = React.lazy(() => import('./views/pages/Sales/DB_Acard'));
const DB_List = React.lazy(() => import('./views/pages/Sales/DB_List'));
const DB_GUP1 = React.lazy(() => import('./views/pages/Sales/DB_GUP1'));
const DB_GUP2 = React.lazy(() => import('./views/pages/Sales/DB_GUP2'));
const DB_ITM = React.lazy(() => import('./views/pages/Sales/DB_ITM'));
const DB_Set_Item = React.lazy(() => import('./views/pages/Admin/DB_Set_Item'));
const DB_Set_G1 = React.lazy(() => import('./views/pages/Admin/DB_Set_G1'));
const DB_Set_Itemdetail = React.lazy(() => import('./views/pages/Admin/DB_Set_ItemDetail'));
const DB_Set_Itemdetail_Occupation = React.lazy(() => import('./views/pages/Admin/DB_Set_ItemDetail_Occupation'));
const DB_Edit_Itemdetail = React.lazy(() => import('./views/pages/Admin/DB_Edit_ItemDetail'));


const DB_InputDetail = React.lazy(() => import('./views/pages/Sales/DB_InputDetail'));
const DB_Input_G01 = React.lazy(() => import('./views/pages/Sales/DB_Input_G01'));
const DB_Input_G07 = React.lazy(() => import('./views/pages/Sales/DB_Input_G07'));



const DB_SaveSelectItem = React.lazy(() => import('./views/pages/Sales/DB_SaveSelectItem'));
const DB_SaveSelectModel = React.lazy(() => import('./views/pages/Sales/DB_SaveSelectModel'));


const DB_InputJob = React.lazy(() => import('./views/pages/Sales/DB_InputJob'));
const DB_Jobtoteam = React.lazy(() => import('./views/pages/Sales/DB_Jobtoteam'));

const DB_Dashboard_RPT = React.lazy(() => import('./views/pages/Sales/DB_Dashboard_RPT'));
const DB_Dashboard_AKEGETDATA = React.lazy(() => import('./views/pages/Sales/DB_Dashboard_AKEGETDATA'));

const Productlist_sold = React.lazy(() => import('./views/pages/Sales/Productlist_Sold'));

const DB_InputNewAcard = React.lazy(() => import('./views/pages/Sales/DB_InputNewAcard'));
const DB_InputNewDB = React.lazy(() => import('./views/pages/Sales/DB_InputNewDB'));



// ========================== DB  V2 =============================

const DB_List_v2 = React.lazy(() => import('./views/pages/Sales/DB_List_V2'));
const DB_InputNewDB_V2 = React.lazy(() => import('./views/pages/Sales/DB_InputNewDB_v2'));
const DB_InputDetail_v2 = React.lazy(() => import('./views/pages/Sales/DB_InputDetail_v2'));
const DB_Input_G01_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G01_V2'));
const DB_Input_G02_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G02_V2'));
const DB_Input_G03_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G03_V2'));
const DB_Input_G04_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G04_V2'));
// const DB_Input_G05_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G05_V2'));
const DB_Input_G07_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G07_V2'));
const DB_Input_G08_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G08_V2'));

const DB_Input_G07_Address_V2 = React.lazy(() => import('./views/pages/Sales/DB_Input_G07_Address_V2'));

// ========================== Reservate =============================

const Reservate_Inputdetail = React.lazy(() => import('./views/pages/Reservate/Reservate_Inputdetail'));


// ========================== Sale info =============================

const SaleInfo_Detail = React.lazy(() => import('./views/pages/SaleInfo/SaleInfo_detail'));


// ========================== TBR =============================

const Rpt_Pre_Finance_Confirm = React.lazy(() => import('./views/pages/TBR/Rpt_Pre_Finance_Confirm'));
const MatchingControl = React.lazy(() => import('./views/pages/TBR/MatchingControl'));



// ========================== Personal ====================


const Personal_InputDetail = React.lazy(() => import('./views/pages/Personal/Personal_InputDetail'));

// ========================== Account ====================
const Rpt_Payment = React.lazy(() => import('./views/pages/Accounting/Rpt_Payment'));
const Acount_FormReceiptcar = React.lazy(() => import('./views/pages/Accounting/Account_FormReceiptcar'));
const Acount_FormPayment = React.lazy(() => import('./views/pages/Accounting/Account_FormPayment'));
const Rpt_Invite = React.lazy(() => import('./views/pages/Accounting/Rpt_Invite'));
const Account_FormInvite = React.lazy(() => import('./views/pages/Accounting/Account_FormInvite'));
const Rpt_Cancel_Booking = React.lazy(() => import('./views/pages/Accounting/Rpt_Cancel_Booking'));
const Rpt_Invite_Detail = React.lazy(() => import('./views/pages/Accounting/Rpt_Invite_Detail'));
const Account_FormInvite_Detail = React.lazy(() => import('./views/pages/Accounting/Account_FormInvite_Detail'));

const Account_FormCancel_Booking = React.lazy(() => import('./views/pages/Accounting/Account_FormCancel_Bk'));

const Rpt_Booking = React.lazy(() => import('./views/pages/Accounting/Rpt_Booking.js'));

const Rpt_Booking_Sup = React.lazy(() => import('./views/pages/Acard/Rpt_Booking_sup.js'));

// ========================== Marketing persona ==================================
const DashboardMP = React.lazy(() => import('./views/pages/dashboard/DashboardMP'));
const Cus_MP_Itm = React.lazy(() => import('./views/pages/MP/Cus_MP_Itm'));
const DB_DashboardMP = React.lazy(() => import('./views/pages/MP/Cus_DashboardMP'));
const Rpt_MP = React.lazy(() => import('./views/pages/MP/Rpt_MP'));

const Message = React.lazy(() => import('./views/pages/MP/Cus_MP_Message'));

// ===================== Stock =======================================

const Productlistbrandbybranch = React.lazy(() => import('./views/pages/Stock/Productlistbrandbybranch'));
const Productlistmodelbybrand = React.lazy(() => import('./views/pages/Stock/Productlistmodelbybrand'));
const Productlistmodel = React.lazy(() => import('./views/pages/Stock/Productlistbymodel'));
const Productdetailbyregister = React.lazy(() => import('./views/pages/Stock/Productdetailbyregister'));
const ProductImageList = React.lazy(() => import('./views/pages/Stock/ProductImageList')); 
const ProductlistbySearch = React.lazy(() => import('./views/pages/Stock/ProductlistbySearch'));

// ===================== Activity =======================================


const Activity = React.lazy(() => import('./views/pages/Activity/Activity'));

const routes = [

  // =========================================================================
  { path: '/', exact: true, name: 'Home', component: Login },
  // { path: '/', exact: true, name: 'Home', component: DashboardWebNgc },
  // =========================================================================

  { path: '/login', name: 'Main menu', component: Login },
  { path: '/dashboard', name: 'Main menu', component: Dashboard },

  { path: '/dashboardwebngc', exact: true, name: 'Main menu', component: DashboardWebNgc },
  { path: '/dashboardwebngc/ngc_s', exact: true, name: 'sell', component: Ngc_s },
  { path: '/dashboardwebngc/ngc_d', exact: true, name: 'detail', component: Ngc_d },
  { path: '/dashboardwebngc/ngc_p', exact: true, name: 'promotion', component: Ngc_p },
  { path: '/dashboardwebngc/ngc_article', exact: true, name: 'article', component: Ngc_Article },
  { path: '/dashboardwebngc/ngc_about', exact: true, name: 'about', component: Ngc_About },
 
  { path: '/dashboardwebngc/ngc_article_detail', exact: true, name: 'detail', component: Ngc_Article_Detail },

  { path: '/dashboardacard', exact: true, name: 'Acard list', component: DashboardAcard },
  { path: '/dashboardacard/acard_inputdetail', exact: true, name: 'Acard details', component: AcardInputDetail },



  { path: '/dashboardacard/acard_inputdetail/acard_info', exact: true, name: 'รายละเอียด', component: Acard_InputInfo },
  { path: '/dashboardacard/acard_inputdetail/acard_address', exact: true, name: 'ที่อยู่', component: Acard_InputAddress },
  { path: '/dashboardacard/acard_inputdetail/acard_model', exact: true, name: 'รุ่นรถ', component: Acard_InputModel },
  { path: '/dashboardacard/acard_inputdetail/acard_campaign', exact: true, name: 'Campaign', component: Acard_Campaign },

  { path: '/dashboardacard/acard_inputdetail/acard_contact', exact: true, name: 'การติดตามงาน', component: Acard_InputContact },
  { path: '/dashboardacard/acard_inputdetail/acard_contact/acard_newcontact', exact: true, name: 'New Contact', component: Acard_NewContact },
  { path: '/dashboardacard/acard_inputdetail/acard_inputpayment', exact: true, name: 'บันทึกรายละเอียดการชำระเงิน', component: Acard_InputPayment },
  { path: '/dashboardacard/acard_inputdetail/acard_inputpartsetitems', exact: true, name: 'บันทึกของแถม', component: Acard_InputPartsetitems },
  { path: '/dashboardacard/acard_inputdetail/acard_fee', exact: true, name: 'ค่าใช้จ่ายอื่น ๆ', component: Acard_InputFee },
  { path: '/dashboardacard/acard_inputdetail/acard_scorecard', exact: true, name: 'ฟอร์ม Score Card', component: Acard_ScoreCard },
  { path: '/dashboardacard/acard_inputdetail/acard_formscorecard/:id', exact: true, name: 'ฟอร์ม Score Card', component: Acard_FormScoreCard },

  { path: '/dashboardacard/acard_inputdetail/acard_payment', exact: true, name: 'Payment', component: Acard_Payment },
  { path: '/dashboardacard/acard_inputdetail/acard_payment/slip', exact: true, name: 'Slip', component: Acard_Payment_Slip },

  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_reservate', exact: true, name: 'Reservate', component: Acard_Reservate },

  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_form_reservate_new', exact: true, name: 'ฟอร์มใบสคบ New', component: Acard_Form_Reservate_New },
  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_ocpb', exact: true, name: 'เรียกดูฟอร์มใบสคบ. 2568', component: Acard_OCPB },
  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_form_ocpb', exact: true, name: 'เรียกดูฟอร์มใบสคบ. 2568', component: Acard_Form_OCPB },
  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_form_ocpb_memo1', exact: true, name: 'ฟอร์มใบสคบ. Memo', component: Acard_Form_OCPB_Memo1 },
  { path: '/dashboardacard/acard_inputdetail/acard_payment/acard_form_ocpb_memo2', exact: true, name: 'ฟอร์มใบสคบ. Memo', component: Acard_Form_OCPB_Memo2 },






  { path: '/dashboardacard/acard_inputdetail/filelist', exact: true, name: 'Acard File List', component: AcardFilelist },
  { path: '/dashboardacard/acard_inputdetail/filelist/filekeep', exact: true, name: 'File Keep', component: Filekeep },

  { path: '/dashboardacard/acard_inputdetail/acard_quatation_list', exact: true, name: 'รายการใบเสนอราคา', component: Acard_Quatation_list },
  { path: '/dashboardacard/acard_inputdetail/acard_quatation_list/acard_quatation', exact: true, name: 'ฟอร์มใบเสนอราคา', component: Acard_Quatation },
  { path: '/dashboardacard/acard_inputdetail/acard_quatation_list/acard_formquatation_approve/:id', exact: true, name: 'ฟอร์มใบขออนุม้ติ', component: Acard_FormQuatation_approve },
  { path: '/dashboardacard/acard_inputdetail/acard_quatation_list/acard_formqr_sale/:id', exact: true, name: 'ฟอร์มใบขออนุม้ติ', component: Acard_FormQR_sale },

  { path: '/dashboardacard/acard_inputdetail/acard_transfer_reservate', exact: true, name: 'ฟอร์มใบ สลับจอง', component: Acard_Transfer_Reservate },
  { path: '/dashboardacard/acard_inputdetail/acard_inputpartsetitems/acard_inputinviteaddress', exact: true, name: 'Acard_InputInviteAddress', component: Acard_InputInviteAddress },

  { path: '/dashboardacard/acard_inputdetail/acard_form_qm1', exact: true, name: 'ฟอร์มใบ QM1', component: Acard_Form_QM1 },
  { path: '/dashboardacard/acard_inputdetail/acard_form_qm1_view', exact: true, name: 'ฟอร์มใบ QM1', component: Acard_Form_QM1_View },


  { path: '/dashboardacard/acard_inputdetail/acard_receiptcar_list', exact: true, name: 'รายการใบรับเงิน', component: Acard_Receiptcar_list },
  { path: '/dashboardacard/acard_inputdetail/acard_receiptcar_list/acard_receiptcar', exact: true, name: 'ใบรับเงิน', component: Acard_Receiptcar },
  { path: '/dashboardacard/acard_inputdetail/acard_receiptcar_list/acard_formreceiptcar', exact: true, name: 'พิมพ์ใบรับเงิน', component: Acard_FormReceiptcar },
  { path: '/dashboardacard/acard_inputdetail/acard_cancel_advancepay', exact: true, name: 'การยกเลิกจองแบบคืนมัดจำ', component: Acard_Cancel_Advancepay },
  { path: '/dashboardacard/acard_inputdetail/acard_fk_invite', exact: true, name: 'ตั้งเบิกค่าแนะนำ', component: Acard_FK_Invite },

  { path: '/dashboardacard/acard_inputdetail/acard_reservate_info', exact: true, name: 'Booking_details', component: Acard_Reservate_Info },


  // =========================  Reservate   ============================

  { path: '/dashboardreservate', exact: true, name: 'Reservate list', component: DashboardReservate },
  { path: '/dashboardreservate/reservate_inputdetail', exact: true, name: 'Reservate details', component: Reservate_Inputdetail },



  // =========================  Approve   ============================

  { path: '/dashboardacard/acard_approve', exact: true, name: 'Approve', component: Acard_Approve_list },
  { path: '/dashboardacard/acard_approve/acard_formqr_approve', exact: true, name: 'ฟอร์มใบขออนุม้ติ', component: Acard_FormQR_approve },
  { path: '/dashboardacard/acard_approve/acard_formquatation', exact: true, name: 'ฟอร์มใบเสนอราคา', component: Acard_FormQuatation },

  { path: '/dashboardacard/acard_approve/acard_approve_qm1', exact: true, name: 'ฟอร์มขออนุม้ติใบ QM1', component: Acard_Approve_QM1 },
  { path: '/dashboardacard/acard_approve/acard_approve_cancel_bk', exact: true, name: 'ฟอร์มขออนุม้ติยกเลิกจอง', component: Acard_Approve_Cancel_Bk },
  { path: '/dashboardacard/acard_approve/acard_approve_tbr_fc', exact: true, name: 'ฟอร์ม Reject รายการ Finance Confirm', component: Acard_Approve_Tbr_Fc },
  { path: '/dashboardacard/acard_approve/acard_approve_booking_vip', exact: true, name: 'ฟอร์มขออนุมัติของ VIP', component: Acard_Approve_Booking_Vip },
  { path: '/dashboardacard/acard_approve/acard_approve_invite', exact: true, name: 'ฟอร์มขออนุมัติตั้งเบิกค่าแนะนำ', component: Acard_Approve_Invite },
  { path: '/dashboardacard/acard_approve/acard_approve_acc_bkcancel', exact: true, name: 'Reject คืนจอง', component: Acard_Approve_Acc_BKCancel },
  { path: '/dashboardacard/acard_approve/acard_approve_acc_invite', exact: true, name: 'Reject ค่าแนะนำ', component: Acard_Approve_Acc_Invite },
  { path: '/dashboardacard/acard_approve/acard_approve_ocpb', exact: true, name: 'ฟอร์มขออนุม้ติใบ สคบ.', component: Acard_Approve_OCPB },

  { path: '/dashboardacard/rpt_booking_sup', exact: true, name: 'รายงานการ Booking', component: Rpt_Booking_Sup },

  // ======================================================

  { path: '/dashboardaccounting', exact: true, name: 'Accounting', component: DashboardAccounting },
  { path: '/dashboardaccounting/rpt_payment', exact: true, name: 'สรุปรายงานการรับเงิน', component: Rpt_Payment },

  { path: '/dashboardaccounting/rpt_payment/account_formreceiptcar', exact: true, name: 'พิมพ์ใบรับเงิน', component: Acount_FormReceiptcar },
  { path: '/dashboardaccounting/rpt_payment/account_formpayment', exact: true, name: 'พิมพ์รายงานการรับเงิน', component: Acount_FormPayment },

  { path: '/dashboardaccounting/rpt_invite', exact: true, name: 'สรุปรายงานการรับเงินค่าแนะนำ', component: Rpt_Invite },
  { path: '/dashboardaccounting/rpt_invite/account_forminvite', exact: true, name: 'พิมพ์รายงานค่าแนะนำ', component: Account_FormInvite },
  { path: '/dashboardaccounting/rpt_invite/account_forminvite_detail', exact: true, name: 'พิมพ์รายละเอียดตั้งเบิกค่าแนะนำ', component: Account_FormInvite_Detail },

  { path: '/dashboardaccounting/rpt_cancel_booking', exact: true, name: 'สรุปรายงานการยกเลิกจอง', component: Rpt_Cancel_Booking },
  { path: '/dashboardaccounting/rpt_cancel_booking/account_formcancel_bk', exact: true, name: 'พิมพ์รายงานยกเลิกจอง', component: Account_FormCancel_Booking },

  { path: '/dashboardaccounting/rpt_invite/rpt_invite_detail', exact: true, name: 'รายละเอียดการตั้งเบิกค่าแนะนำ', component: Rpt_Invite_Detail },

  { path: '/dashboardaccounting/rpt_booking', exact: true, name: 'สรุปรายงานการ Booking', component: Rpt_Booking },

  { path: '/dashboardaccounting/rpt_payment/acard_form_qm1', exact: true, name: 'ฟอร์มใบ QM1', component: Acard_Form_QM1 },
  { path: '/dashboardaccounting/rpt_booking/acard_form_qm1', exact: true, name: 'ฟอร์มใบ QM1', component: Acard_Form_QM1 },

  // ======================================================
  { path: '/dashboardtbr/rpt_pre_finance_confirm', exact: true, name: 'รายการ Pre-Finance confirm ', component: Rpt_Pre_Finance_Confirm },
  { path: '/dashboardtbr/matchingcontrol', exact: true, name: 'Functions Matching control', component: MatchingControl },

  { path: '/dashboardtbr/rpt_pre_finance_confirm/acard_form_qm1', exact: true, name: 'ฟอร์มใบ QM1', component: Acard_Form_QM1 },



  // ======================================================
  { path: '/dashboardpaymentcheck/rpt_paymentcheck', exact: true, name: 'Check Payment_Check', component: DashboardPayment_Check },


  // ========================= File Keep   ============================

  { path: '/filelist/filekeep', exact: true, name: 'File Keep', component: Filekeep2 },
  { path: '/filelist/filetypelist/:id', exact: true, name: 'File Type', component: FileTypelist },
  { path: '/filelist', exact: true, name: 'File List', component: Filelist },



  // =========================  Sale Info   ============================

  { path: '/dashboardsaleinfo', exact: true, name: 'SaleInfo list', component: DashboardSaleInfo },
  { path: '/dashboardsaleinfo/saleinfodetail', exact: true, name: 'SaleInfo detail', component: SaleInfo_Detail },


  // =========================  Person  ============================


  { path: '/dashboardperson', exact: true, name: 'แฟ้มข้อมูลผู้เกี่ยวข้องกับงานขาย', component: DashboardPerson },

  // =========================  Banner  ============================


  { path: '/dashboardmessage', exact: true, name: 'Dashboard Message', component: DashboardMessage },
  { path: '/dashboardmessage/cus_mp_message', exact: true, name: 'Message', component: Message },


  { path: '/dashboardfileimage', name: 'Menu FileImage', component: DashboardFileImage },

  { path: '/dashboardsummary', name: 'Report', component: DashboardSummary },
  { path: '/dashboardfilekeeps', name: 'Menu FileKeep', component: DashboardFileKeep },
  { path: '/dashboardfilekeep/:id', name: 'Menu FileKeep', component: DashboardFileKeep },


  { path: '/sales/job_modelname/:id', exact: true, name: 'Job_Brand', component: Job_Modelname },
  { path: '/sales/job_modelspec/:id', exact: true, name: 'Job_Model', component: Job_Modelspec },
  { path: '/sales/job_inputselect/:id', exact: true, name: 'Job_InputSelect', component: Job_InputSelect },
  { path: '/sales/job_inputtarget/:id', exact: true, name: 'Job_InputTarget', component: Job_InputTarget },

  { path: '/sales/db_inputnewacard', exact: true, name: 'DB_InputNewAcard', component: DB_InputNewAcard },
  { path: '/sales/db_jobtoteam/:id', exact: true, name: 'DB_Jobtoteam', component: DB_Jobtoteam },
  { path: '/sales/db_inputnewdb', exact: true, name: 'DB_InputNewDB', component: DB_InputNewDB },
  { path: '/sales/db_exportexcelteam/:id', exact: true, name: 'DB_Exportexcelteam', component: DB_Exportexcelteam },
  { path: '/sales/db_jobformpdf/:id', exact: true, name: 'DB_JobFormPDF', component: DB_JobFormPDF },


  { path: '/sales/db_dashboard_rpt', exact: true, name: 'DB_Dashboard_RPT', component: DB_Dashboard_RPT },
  { path: '/sales/db_dashboard_akegetdata', exact: true, name: 'DB_Dashboard_AKEGETDATA', component: DB_Dashboard_AKEGETDATA },




  { path: '/sales/acard_list', exact: true, name: 'Acard_List', component: Acard_List },
  { path: '/sales/acard', exact: true, name: 'Acard', component: Acard },
  { path: '/sales/acard/:id', exact: true, name: 'Acard', component: Acard },


  { path: '/sales/acard_info/:id', exact: true, name: 'Acard_Info', component: Acard_Info },

  { path: '/sales/productlist_sold', exact: true, name: 'รถขายแล้ว', component: Productlist_sold },



  { path: '/sales/db_acard/:id', exact: true, name: 'DB_Acard', component: DB_Acard },

  { path: '/sales/db_joblist', exact: true, name: 'Marketing plan list', component: DB_JobList },


  { path: '/sales/db_joblist/db_inputjob/:id', exact: true, name: 'Marketing plan details', component: DB_InputJob },


  { path: '/sales/db_save_select_item/:id', exact: true, name: 'DB_SaveSelectItem', component: DB_SaveSelectItem },

  { path: '/sales/db_save_select_model/:id', exact: true, name: 'DB_SaveSelectModel', component: DB_SaveSelectModel },


  // =========================  DB  ============================

  { path: '/sales/db_summary_by_job', exact: true, name: 'DB_Summary_by_job', component: DB_Summary_by_job },

  { path: '/sales/db_summary_by_sales', exact: true, name: 'DB_Summary_by_sales', component: DB_Summary_by_sales },

  { path: '/sales/db_pdfsummarybysales', exact: true, name: 'DB_PDFsummaryBySales', component: DB_PDFsummaryBySales },
  { path: '/sales/db_pdfsummarybysales_detail', exact: true, name: 'DB_PDFsummaryBySales_detail', component: DB_PDFsummaryBySales_detail },



  { path: '/sales/db_list', exact: true, name: 'รายชื่อลูกค้า DB', component: DB_List },

  { path: '/sales/db_list/db_gup1/:id', exact: true, name: 'รายละเอียด DB', component: DB_GUP1 },
  { path: '/sales/db_list/db_inputdetail', exact: true, name: 'รายละเอียด DB', component: DB_InputDetail },

  { path: '/sales/db_list/db_inputdetail/db_input_g01', exact: true, name: 'รายละเอียด G01', component: DB_Input_G01 },
  { path: '/sales/db_list/db_inputdetail/db_input_g07', exact: true, name: 'รายละเอียด G07', component: DB_Input_G07 },




  { path: '/sales/db_gup2', exact: true, name: 'Primary_GUP2', component: DB_GUP2 },
  { path: '/sales/db_gup2/:id', exact: true, name: 'Primary_GUP2', component: DB_GUP2 },
  { path: '/sales/db_itm/:id', exact: true, name: 'DB_ITM', component: DB_ITM },

  // =========================  db  V2  ============================

  { path: '/sales/db_list_v2', exact: true, name: 'รายชื่อลูกค้า DB V2', component: DB_List_v2 },
  { path: '/sales/db_list_v2/db_inputnewdb_v2', exact: true, name: 'เพิ่มรายชื่อ DB ใหม่', component: DB_InputNewDB_V2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2', exact: true, name: 'รายละเอียด DB', component: DB_InputDetail_v2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g01_v2', exact: true, name: 'รายละเอียด G01', component: DB_Input_G01_V2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g02_v2', exact: true, name: 'รายละเอียด G02', component: DB_Input_G02_V2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g03_v2', exact: true, name: 'รายละเอียด G03', component: DB_Input_G03_V2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g04_v2', exact: true, name: 'รายละเอียด G04', component: DB_Input_G04_V2 },
  //  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g05_v2', exact: true, name: 'รายละเอียด G05', component: DB_Input_G05_V2  },


  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g07_v2', exact: true, name: 'รายละเอียด G07', component: DB_Input_G07_V2 },
  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g08_v2', exact: true, name: 'รายละเอียด G08', component: DB_Input_G08_V2 },



  { path: '/sales/db_list_v2/db_inputdetail_v2/db_input_g07_address_v2', exact: true, name: 'รายละเอียดที่อยู่ G07', component: DB_Input_G07_Address_V2 },


  // =========================  Personal  ============================

  { path: '/dashboardperson/personal_inputdetail', exact: true, name: 'รายละเอียด', component: Personal_InputDetail },





  // =========================  Admin  ============================





  { path: '/admin/dashboardgup1', exact: true, name: 'Dashboard GUP1', component: DB_Set_G1 },
  { path: '/admin/dashboardgup1/db_set_item', exact: true, name: 'Item', component: DB_Set_Item },
  { path: '/admin/dashboardgup1/db_set_item/db_set_itemdetail', exact: true, name: 'Item Detail', component: DB_Set_Itemdetail },
  { path: '/admin/dashboardgup1/db_set_item/db_set_itemdetail_occupation', exact: true, name: 'Item Detail Occupation', component: DB_Set_Itemdetail_Occupation },

  { path: '/admin/dashboardgup1/db_set_item/db_set_itemdetail/db_edit_itemdetail', exact: true, name: 'Update Item Detail', component: DB_Edit_Itemdetail },


  // =========================  User  ============================
  { path: '/user', exact: true, name: 'User Details', component: User },
  { path: '/newuser/:id', exact: true, name: 'NewUser', component: NewUser },

  { path: '/users', exact: true, name: 'Users Back End', component: Users },
  { path: '/users/:id', exact: true, name: 'User Details', component: User },
  { path: '/authorize', exact: true, name: " User Rolls", component: UserAuthorize },

  { path: '/menuitem/:id', exact: true, name: 'Menu Item', component: MenuItem },
  { path: '/menuitems', exact: true, name: 'Menu Items', component: MenuItems },

  // ============================================================


  { path: '/admin/otp_list', exact: true, name: 'Dashboard OTP', component: OTP_List },

  // =========================  Marketing persona  ============================


  { path: '/dashboardMP', exact: true, name: 'Dashboard MP', component: DashboardMP },
  { path: '/dashboardMP/cus_rp_mp', exact: true, name: 'Report MP', component: Rpt_MP },

  { path: '/dashboardMP/cus_mp_itm', exact: true, name: 'MP Question', component: Cus_MP_Itm },
  { path: '/sales/db_list/db_inputdetail/dashboardMP', exact: true, name: 'รายละเอียด MP', component: DB_DashboardMP },



  // =========================  Product Stock  ============================
  { path: '/dashboardstock', exact: true, name: 'สาขา', component: DashboardStock },
  { path: '/dashboardstock/Productlistbrandbybranch', exact: true, name: 'ยี่ห้อ', component: Productlistbrandbybranch },
  { path: '/dashboardstock/Productlistbrandbybranch/Productlistmodelbybrand', exact: true, name: 'รุ่น', component: Productlistmodelbybrand },
  { path: '/dashboardstock/Productlistbrandbybranch/Productlistmodelbybrand/Productlistmodel', exact: true, name: 'รายการ', component: Productlistmodel },
  { path: '/dashboardstock/Productlistbrandbybranch/Productlistmodelbybrand/Productlistmodel/Productdetailbyregister', exact: true, name: 'รายละเอียด', component: Productdetailbyregister },
  { path: '/dashboardstock/Productlistbrandbybranch/Productlistmodelbybrand/Productlistmodel/Productdetailbyregister/ImageList', exact: true, name: 'รายละเอียด', component: ProductImageList },


  { path: '/dashboard_activity', name: 'Menu FileAcitvity', component: Dashboard_Activity },
  { path: '/dashobard_activity/activity', name: 'New FileAcitvity', component: Activity },

 
  { path: '/dashboardstock/ProductlistbySearch', exact: true, name: 'ค้นหา', component: ProductlistbySearch },
  

];

export default routes;
